import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
    // mode: 'history', // 启用 History 模式
    routes: [
        //登录
        {
          // path: '/',
            // redirect: '/Login',
            path: '/',
            // redirect: '/HomePage',
            redirect: () => {
                // // 根据不同的访问域名进行重定向
                const baseUrl = window.location.origin + window.location.pathname;
                if (window.location.hostname === 'www.yantai360.com' || window.location.hostname === 'yantai360.com') {
                  return '/HomePage';
                } else if (window.location.hostname === 'cscec8z.yantai360.com'|| window.location.hostname === '369smart.com' || window.location.hostname === '369smart.cn') {
                  return '/LoginPro';
                } else if(baseUrl.includes("V7UbDmSC") ){
                    return '/V7UbDmSC';
                }else{
                  return '/LoginPro'; // 默认重定向
                }
              }  
        },{//产品首页22.01.13；
            path:'/HomePage',
            component:resolve =>require(['../pages/HomePage/HomePage.vue'],resolve),
            meta:{title:'深圳岩泰科技有限公司'}
        },{//产品首页跳转登录页面；22.01.14
            path: '/LoginPro',
            component: resolve => require(['../pages/HomePage/Login/Login.vue'], resolve),
            meta: { title: '结构健康监测管理系统' }
        },{
            path: '/Login',
            component: resolve => require(['../pages/Login/login.vue'], resolve),
            meta: { title: '登录' }
        },
        // bi-ifarme登陆
        {
            path: '/loginIframe',
            component: resolve => require(['../pages/Login/loginIframe.vue'], resolve),
            meta: { title: '登录' }
        },
        {
            path: '/V7UbDmSC',
            component: resolve => require(['../pages/Login/shortlink.vue'], resolve),
            meta: { title: '岩泰监测 Android版本APK下载' }
        },
        //后台
        {
            path: '/frameWork_index',
            component: resolve => require(['../pages/Home/frameWork/index.vue'], resolve),
            children: [{
                path: '/frameWork_homePage',
                component: resolve => require(['../pages/Home/frameWork/homePage.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/frameWork_map',
                component: resolve => require(['../pages/Home/frameWork/head/map.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/frameWork_addressList',
                component: resolve => require(['../pages/Home/frameWork/head/addressList.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/frameWork_download',
                component: resolve => require(['../pages/Home/frameWork/head/download.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/frameWork_mainManage',
                component: resolve => require(['../pages/Home/systemManage/mainManage.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/frameWork_projectManage',
                component: resolve => require(['../pages/Home/systemManage/projectManage.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },
            {
                path: '/Dictionaries',
                component: resolve => require(['../pages/Home/systemManage/DictionariesManage.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },
            {
                path: '/Guidance',
                component: resolve => require(['../pages/Home/systemManage/guidance.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },
            {
                path: '/frameWork_joinBuildManage',
                component: resolve => require(['../pages/Home/systemManage/joinBuildManage.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/frameWork_userManage',
                component: resolve => require(['../pages/Home/systemManage/userManage.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/frameWork_operationLog',
                component: resolve => require(['../pages/Home/systemManage/operationLog.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },
            {
                path: '/frameWork_reportExport',
                component: resolve => require(['../pages/Home/systemManage/reportExport.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/worksRegistration_index',
                component: resolve => require(['../pages/Home/worksRegistration/index.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/supervisionClarificaiton_index',
                component: resolve => require(['../pages/Home/supervisionClarificaiton/index.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/supervisionClarificaiton_meeting',
                component: resolve => require(['../pages/Home/supervisionClarificaiton/meeting.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/safetyCulture_index',
                component: resolve => require(['../pages/Home/safetyCulture/index.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/stageAcceptance_index',
                component: resolve => require(['../pages/Home/stageAcceptance/index.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/finalAcceptance_index',
                component: resolve => require(['../pages/Home/finalAcceptance/index.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/recordsAcceptance_index',
                component: resolve => require(['../pages/Home/recordsAcceptance/index.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/dangerousBigProject_index',
                component: resolve => require(['../pages/Home/dangerousBigProject/index.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/basicData_monitorTerminal',
                component: resolve => require(['../pages/Home/basicData/monitorTerminal.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/basicData_mechanicalEquip',
                component: resolve => require(['../pages/Home/basicData/mechanicalEquip.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/basicData_projectCooperator',
                component: resolve => require(['../pages/Home/basicData/projectCooperator.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/basicData_position',
                component: resolve => require(['../pages/Home/basicData/position.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/basicData_projectInfo',
                component: resolve => require(['../pages/Home/basicData/projectInfo.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },  {
                path: '/basicData_projectDeviceUpKeep',
                component: resolve => require(['../pages/Home/basicData/projectDeviceUpKeep.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {///basicData_DataForwarding
                path: '/basicData_Transferlib',
                component: resolve => require(['../pages/Home/basicData/Transferlib.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/deviceManage_data',
                component: resolve => require(['../pages/Home/deviceManage/data.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/deviceManage_file',
                component: resolve => require(['../pages/Home/deviceManage/file.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/YCMonitor_index',
                component: resolve => require(['../pages/Home/YCMonitor/index.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/videoJK_index',
                component: resolve => require(['../pages/Home/videoJK/index.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/peopleManage_peopleRealName',
                component: resolve => require(['../pages/Home/peopleManage/peopleRealName.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/peopleManage_manageStatistics',
                component: resolve => require(['../pages/Home/peopleManage/manageStatistics.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/peopleManage_labourStatistics',
                component: resolve => require(['../pages/Home/peopleManage/labourStatistics.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/peopleManage_RFIDLocaltion',
                component: resolve => require(['../pages/Home/peopleManage/RFIDLocaltion.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/JK_onLine',
                component: resolve => require(['../pages/Home/JK/onLine.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/JK_dataCenter',
                component: resolve => require(['../pages/Home/JK/dataCenter.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/JK_pointInfor',
                component: resolve => require(['../pages/Home/JK/pointInfor.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/GZM_onLine',
                component: resolve => require(['../pages/Home/GZM/onLine.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/GZM_dataCenter',
                component: resolve => require(['../pages/Home/GZM/dataCenter.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/GZM_pointInfor',
                component: resolve => require(['../pages/Home/GZM/pointInfor.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/JSJ_onLine',
                component: resolve => require(['../pages/Home/JSJ/onLine.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/JSJ_dataCenter',
                component: resolve => require(['../pages/Home/JSJ/dataCenter.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/JSJ_pointInfor',
                component: resolve => require(['../pages/Home/JSJ/pointInfor.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/LQS_onLine',
                component: resolve => require(['../pages/Home/LQS/onLine.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/LQS_dataCenter',
                component: resolve => require(['../pages/Home/LQS/dataCenter.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/LQS_pointInfor',
                component: resolve => require(['../pages/Home/LQS/pointInfor.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/ZNJD_onLine',
                component: resolve => require(['../pages/Home/ZNJD/onLine.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/ZNJD_dataCenter',
                component: resolve => require(['../pages/Home/ZNJD/dataCenter.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/ZNJD_pointInfor',
                component: resolve => require(['../pages/Home/ZNJD/pointInfor.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },
            {
                path: '/MqttTest',
                component: resolve => require(['../pages/Home/Mqtt/MqttTest.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, 
            {
                path: '/DSOnlineMonitoring_old',
                component: resolve => require(['../pages/Home/DeviationSurvey/DSOnlineMonitoring.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },  {
                path: '/DSOnlineMonitoring',
                component: resolve => require(['../pages/Home/DeviationSurvey/DSOnlineMonitoring2.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },{
                path: '/DSDataTraceability',
                component: resolve => require(['../pages/Home/DeviationSurvey/DSDataTraceability.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/DSDataReport',
                component: resolve => require(['../pages/Home/DeviationSurvey/DSDataReport.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },  {
                path: '/DSDataAnalyz',
                component: resolve => require(['../pages/Home/DeviationSurvey/DSDataAnalyz.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },{
                path: '/DSDataDetails',
                component: resolve => require(['../pages/Home/DeviationSurvey/GdModel.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/DSAnalyzing',
                component: resolve => require(['../pages/Home/DeviationSurvey/DSDataCenter.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/DSParameterMg',
                component: resolve => require(['../pages/Home/DeviationSurvey/DSParameterMg.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },{
                path: '/DSTestDetails',
                component: resolve => require(['../pages/Home/DeviationSurvey/DSDataDetails.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/WTOnlineMonitoring',//水位
                component: resolve => require(['../pages/Home/WaterLevel/DSOnlineMonitoring2.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/WTOnlineMonitoring_old',//水位旧版
                component: resolve => require(['../pages/Home/WaterLevel/DSOnlineMonitoring.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },{
                path: '/WT_dataCenter',//水位
                component: resolve => require(['../pages/Home/WaterLevel/DSDataTraceability.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },  {
                path: '/WT_DSAnalyzing',//水位
                component: resolve => require(['../pages/Home/WaterLevel/DSDataAnalyz.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },{
                path: '/WT_DSParameterMg',//水位
                component: resolve => require(['../pages/Home/WaterLevel/DSParameterMg.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },
            {
                path: '/SY_DSDataReport',//水位\
                component: resolve => require(['../pages/Home/WaterLevel/DSDataReport.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, 
            {
                path: '/WYOnlineMonitoring',//位移
                component: resolve => require(['../pages/Home/Deviation/DSOnlineMonitoring.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/WY_dataCenter',//位移
                component: resolve => require(['../pages/Home/Deviation/DSDataTraceability.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },  {
                path: '/WY_DSAnalyzing',//位移
                component: resolve => require(['../pages/Home/Deviation/DSDataAnalyz.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },{
                path: '/WY_DSParameterMg',//位移
                component: resolve => require(['../pages/Home/Deviation/DSParameterMg.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },{
                path: '/WY_DSDataReport',//位移
                component: resolve => require(['../pages/Home/Deviation/DSDataReport.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },{
                path: '/Version_App',//安卓版本管理
                component: resolve => require(['../pages/Home/VersionApp/versionApp.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },{
                path: '/Feed_Back',//意见反馈
                component: resolve => require(['../pages/Home/feedBack/FeedBack.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            },{
                path: '/CJOnlineMonitoring',//沉降在线监测
                component: resolve => require(['../pages/Home/settle/DSOnlineMonitoring.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/CJDataTraceability',//沉降数据溯源
                component: resolve => require(['../pages/Home/settle/DSDataTraceability.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/CJParameterMg',//沉降参数管理
                component: resolve => require(['../pages/Home/settle/DSParameterMg.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/QJOnlineMonitoring',//倾角在线监测
                component: resolve => require(['../pages/Home/dipAngle/DSOnlineMonitoring2.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/QJOnlineMonitoring_old',//水位旧版
                component: resolve => require(['../pages/Home/dipAngle/DSOnlineMonitoring.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/QJDataTraceability',//倾角数据溯源
                component: resolve => require(['../pages/Home/dipAngle/DSDataTraceability.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/QJParameterMg',//倾角参数管理
                component: resolve => require(['../pages/Home/dipAngle/DSParameterMg.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/CJDataReport',//沉降数据报表
                component: resolve => require(['../pages/Home/settle/DSDataReport.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/QJDataReport',//倾角数据报表
                component: resolve => require(['../pages/Home/dipAngle/DSDataReport.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/LSOnlineMonitoring',//拉绳在线监测
                component: resolve => require(['../pages/Home/rope/DSOnlineMonitoring.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/LSDataTraceability',//拉绳数据溯源
                component: resolve => require(['../pages/Home/rope/DSDataTraceability.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/LSParameterMg',//拉绳参数管理
                component: resolve => require(['../pages/Home/rope/DSParameterMg.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/LSDataReport',//拉绳数据报表
                component: resolve => require(['../pages/Home/rope/DSDataReport.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/ZLOnlineMonitoring',//轴力在线监测
                component: resolve => require(['../pages/Home/axial/DSOnlineMonitoring2.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/ZLOnlineMonitoring_old',//轴力在线监测
                component: resolve => require(['../pages/Home/axial/DSOnlineMonitoring.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/ZLDataTraceability',//轴力数据溯源
                component: resolve => require(['../pages/Home/axial/DSDataTraceability.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/ZLParameterMg',//轴力参数管理
                component: resolve => require(['../pages/Home/axial/DSParameterMg.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/ZLDataReport',//轴力数据报表
                component: resolve => require(['../pages/Home/axial/DSDataReport.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/YLOnlineMonitoring',//压力在线监测
                component: resolve => require(['../pages/Home/pressure/DSOnlineMonitoring.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/YLDataTraceability',//压力数据溯源
                component: resolve => require(['../pages/Home/pressure/DSDataTraceability.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/YLParameterMg',//压力参数管理
                component: resolve => require(['../pages/Home/pressure/DSParameterMg.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/YLDataReport',//压力数据报表
                component: resolve => require(['../pages/Home/pressure/DSDataReport.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/StressOnlineMonitoring',//应力在线监测
                component: resolve => require(['../pages/Home/stress/DSOnlineMonitoring2.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/StressDataTraceability',//应力数据溯源
                component: resolve => require(['../pages/Home/stress/DSDataTraceability.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/StressParameterMg',//应力参数管理
                component: resolve => require(['../pages/Home/stress/DSParameterMg.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }, {
                path: '/StressDataReport',//应力数据报表
                component: resolve => require(['../pages/Home/stress/DSDataReport.vue'], resolve),
                meta: { title: '结构健康监测管理系统' }
            }
        ]
        },
        //BI/
        {
            path: '/BI_index',
            component: resolve => require(['../pages/BI/index.vue'], resolve),
            children: []
        },
        {
            path: '/BI2_index',
            component: resolve => require(['../pages/BI2.0/PanoramaViewer.vue'], resolve),
            children: []
        },
        // BI_iframe
        {
            path: '/BI_iframe_index',
            component: resolve => require(['../pages/BI/IframeIndex.vue'], resolve),
            children: []
        },

        //Android
        {
            path: '/Home_alarmDetails',
            component: resolve => require(['../pages/Android/Home/alarmDetails.vue'], resolve),
            children: []
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js